// extracted by mini-css-extract-plugin
export default {"errorIcon":"DropdownSettings-module__errorIcon___Vq_W4"};